/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proxy_HintInputs */



/**
* | output |
* | --- |
* | "Fills an empty seat without competing: no rank, no rating, no finals. Their VPs still count for their opponents." |
*
* @param {Proxy_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const proxy_hint = /** @type {((inputs?: Proxy_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proxy_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplit une place vide sans jouer le tournoi : ni classement, ni rating, ni finale. Ses VP comptent quand même pour ses adversaires.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ocupa una plaza vacía sin competir: sin clasificación, sin rating, sin final. Sus VP sí cuentan para sus rivales.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ocupa uma vaga vazia sem competir: sem classificação, sem pontos, sem final. Os VP dele ainda contam para os adversários.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Occupa un posto vuoto senza gareggiare: niente classifica, niente rating, niente finale. I suoi VP contano comunque per gli avversari.")
	return /** @type {LocalizedString} */ ("Fills an empty seat without competing: no rank, no rating, no finals. Their VPs still count for their opponents.")
});